import { MacBookWindow } from '@rumblefish/ui/Rumblefish23Theme';
import { scrollToElement } from '../../../utils/handleScroll';
import { rustWebAppContactFormId } from '../RustWebAppDevelopmentPage.consts';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={<>Rust Web App Development Services</>}
        description={
          <>
            Build Lightning-Fast Web Applications <b>with Rust</b>
          </>
        }
        buttonText="Let's talk about your project"
        buttonLink="/contact"
        buttonHandleOnClick={() => scrollToElement(rustWebAppContactFormId)}
        gradient="orange"
      />
    </>
  );
};
